import { Typography } from '../ui';

/**
 * EmptyTabMessage
 *
 * Quiet placeholder line shown inside a learner course-detail tab (CE,
 * Instructor, Overview) when that tab has no content yet.
 */
export default function EmptyTabMessage({ message }: { message: string }) {
  return (
    <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
      {message}
    </Typography>
  );
}
